import { ValidationError } from '../../gs-core/common';
import { Subject } from './Subject';
import { SubjectTypes } from './SubjectType';

export type ViewAccess = 'OWNING_UNIT' | 'SUBJECTS_GROUPS' | 'SUBJECTS_GROUPS_AND_SUBJECT';

export const ViewAccessTypes = {
  OWNING_UNIT: 'OWNING_UNIT' as ViewAccess,
  SUBJECTS_GROUPS: 'SUBJECTS_GROUPS' as ViewAccess,
  SUBJECTS_GROUPS_AND_SUBJECT: 'SUBJECTS_GROUPS_AND_SUBJECT' as ViewAccess,

  parse(code: string): ViewAccess {
    if (!code || typeof code !== 'string' || code.toUpperCase() !== code || !(code in ViewAccessTypes)) {
      throw new ValidationError(`Invalid view access type ${code}`) ;
    }

    return ViewAccessTypes[code];
  },

  get ALL(): ViewAccess[] {
    return Object.keys(ViewAccessTypes)
      .filter(key => key !== 'ALL' && typeof ViewAccessTypes[key] === 'string')
      .map(key => ViewAccessTypes[key]);
  },

  filterBySubject(subject?: Subject): ViewAccess[] {
    if (subject && subject.type === SubjectTypes.PROGRAM) {
      return [ViewAccessTypes.OWNING_UNIT, ViewAccessTypes.SUBJECTS_GROUPS];
    }

    return ViewAccessTypes.ALL;
  }
};



// WEBPACK FOOTER //
// ./src/common/models/ViewAccess.ts